import React from "react";
import get from "lodash/get";
import PropTypes from "prop-types";
import { SocialShare, Link, StoryElement } from "@quintype/components";
import { StoryCard } from "./../story-card";
import { StickySocialShareTemplate } from "./../sticky-social-share";
import RelatedStories from "./../related-stories";
import { StoryTags } from "../story-tags";
import { Instagram } from "../../atoms/icons/instagram";
import { Facebook } from "../../atoms/icons/facebook";
import { Linkedin } from "../../atoms/icons/linkedin";
import { Twitter } from "../../atoms/icons/twitter";
import { User } from "../../atoms/icons/user";
import humanizeDate from "../../utils/time-format";
import { TrendingNewsCarousel } from "../../trending-news-carousel";
import "./styles.m.css";
import { DfpAd } from "../../atoms/dfp-ad";
import fetch from "isomorphic-fetch";
import { changeHttpToHttps, storyShareClickHandler } from "../../utils/utils";

export class VideoStoryTemplate extends React.Component {
  constructor() {
    super();
    this.state = {
      renderMetype: false,
      showTrendingStories: false,
      authorsData: []
    };
    this.generateCards = this.generateCards.bind(this);
  }
  componentDidMount() {
    this.setState({
      renderMetype: true,
      showTrendingStories: true
    });
    fetch(`/api/v1/authors`)
      .then(response => {
        return response.json();
      })
      .then(data => {
        this.setState({ authorsData: data.authors });
      });
  }

  generateCards() {
    return this.props.story.cards.map((card, index) => {
      return <StoryCard key={card.id + index} card={card} story={this.props.story} />;
    });
  }

  render() {
    const avatarUrl = get(this.props.story, ["authors", "0", "avatar-url"]);
    const color = get(this.props.story, ["sections", "0", "data", "color"], "#2F2BAD");
    const style = {
      "background-color": color
    };
    const firstSection = get(this.props.story, ["sections", "0"], []);
    const fulfillmentTrendingStories = get(this.props, ["trendingStories", "fulfillmentValue"], []);
    const trendingStories = fulfillmentTrendingStories.map(trendingStory => trendingStory.story);

    const story = Object.assign({}, this.props.story);
    const getPrimaryVideo = cards => {
      const headerVideo = [];
      cards.forEach(function(card) {
        card["story-elements"].forEach(function(element) {
          if (element["type"] === "youtube-video" || element["subtype"] === "vimeo-video") {
            headerVideo.push(element);
          }
        });
      });
      return headerVideo[0];
    };
    const primaryVideo = getPrimaryVideo(story.cards);

    function getCards(story, primaryVideoID) {
      let storyCards = story.cards.map(card => {
        const newCard = Object.assign({}, card);
        let elements = card["story-elements"].filter(element => element.id !== primaryVideoID);
        newCard["story-elements"] = elements;
        return newCard;
      });
      story.cards = storyCards;
      return story;
    }
    const storyProps = primaryVideo ? getCards(story, primaryVideo.id) : this.props.story;
    const generateCards = story => {
      return story.cards.map((card, index) => {
        return <StoryCard key={card.id + index} card={card} story={this.props.story} />;
      });
    };
    const authorName = get(this.props, ["story", "authors", "0", "name"], " ");
    const authorTwitter = get(this.props.story, ["authors", "0", "twitter-handle"], "");
    const authorId = this.props.story.authors[0].id;
    const storyAuthorDetails = this.state.authorsData.filter(authorData => authorData.id === authorId);
    const authorInstagram = get(storyAuthorDetails[0], ["metadata", "instagram"], "");
    const authorLinkedIn = get(storyAuthorDetails[0], ["metadata", "linkedin"], "");
    const authorFacebook = get(storyAuthorDetails[0], ["metadata", "facebook"], "");
    const authorUrl = changeHttpToHttps(this.props.story.authors[0]["avatar-url"]);
    const publisherUrl = get(this.props, ["config", "sketches-host"], "https://www.sme10x.com");

    return (
      <div styleName="blank-story">
        {this.state.showTrendingStories &&
          trendingStories.length > 1 && <TrendingNewsCarousel stories={trendingStories} config={this.props.config} />}
        <div styleName="story-video">
          <StoryElement element={primaryVideo} story={this.props.story} />
        </div>
        <div styleName="blank-story-body-wrap">
          <SocialShare
            template={StickySocialShareTemplate}
            title={this.props.story.headline}
            url={this.props.story.slug}
            hashtags={this.props.story && this.props.story.tags.map(tag => tag.name).toString()}
            color="#1c1c1c"
            sticky
            onClick={storyShareClickHandler(
              this.props.story["story-content-id"],
              `${publisherUrl}/${this.props.story.slug}`
            )}
          />
          <div styleName="blank-story-body">
            <div styleName="author-section-container">
              <div styleName="author-container">
                <div styleName="author-name">{authorName}</div>
                <div styleName="social-icons">
                  <span styleName="author-link">Connect With Me On</span>
                  <div styleName="author-links">
                    {authorFacebook && (
                      <a styleName={`icon`} target="_blank" rel="noopener noreferrer" href={authorFacebook}>
                        <Facebook width="6" height="13" color="white" />
                      </a>
                    )}
                    {authorTwitter && (
                      <a
                        styleName={`icon`}
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`https://twitter.com/${authorTwitter}`}
                      >
                        <Twitter width="12" height="10" color="white" />
                      </a>
                    )}
                    {authorLinkedIn && (
                      <a styleName={`icon`} target="_blank" rel="noopener noreferrer" href={authorLinkedIn}>
                        <Linkedin width="13" height="10" color="white" />
                      </a>
                    )}
                    {authorInstagram && (
                      <a styleName={`icon`} target="_blank" rel="noopener noreferrer" href={authorInstagram}>
                        <Instagram width="11.4" height="11.4" color="white" />
                      </a>
                    )}
                  </div>
                </div>
                <div styleName="author-image">{avatarUrl ? <img src={authorUrl} /> : <User />}</div>
                <div styleName="side-bleeding" />
                <div styleName="pink-bleeding" />
              </div>
              {firstSection.name && (
                <Link href={`/${firstSection.slug}`} styleName="section-name-container" style={style}>
                  {firstSection.name}
                </Link>
              )}
            </div>
            <div styleName="published-date">
              Published: <time>{humanizeDate(this.props.story["last-published-at"])}</time>
            </div>
            {this.props.story.headline && <h1 styleName="story-headline">{this.props.story.headline}</h1>}
            {this.props.story.subheadline && <div styleName="story-subheadline">{this.props.story.subheadline}</div>}

            {generateCards(storyProps)}

            <StoryTags tags={this.props.story.tags} color={color} />
          </div>
        </div>
        <div styleName="sponsored-bio-ad">
          <DfpAd adtype="StorySponsoredBio" />
        </div>
        <RelatedStories relatedStories={this.props.relatedStories} color={color} />
      </div>
    );
  }
}

VideoStoryTemplate.propTypes = {
  story: PropTypes.object,
  config: PropTypes.object,
  relatedStories: PropTypes.array
};

function VideoStory({ story, relatedStories, config, trendingStories }) {
  return (
    <VideoStoryTemplate
      story={story}
      relatedStories={relatedStories}
      config={config}
      trendingStories={trendingStories}
    />
  );
}

VideoStory.propTypes = {
  story: PropTypes.object,
  relatedStories: PropTypes.array,
  config: PropTypes.object,
  trendingStories: PropTypes.array
};

export { VideoStory };
